import React, { useState, useEffect } from 'react';
import useAxios from '@/hooks/use-axios';
import { ImageOff } from 'lucide-react';
import { cn } from "@/lib/utils"
import { dialog } from '@/lib/dialog';

const Image = ({
  content,        // bisa berupa base64, path, atau ID file
  alt = '',
  fallback = '/fallback-image.png',
  className = '',
  onLoad,
  onError,
  timeout = 600,
  popupImage = false
}) => {
  const [imgSrc, setImgSrc] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  const api = useAxios();

  // Fungsi untuk ambil gambar dari server jika content berupa ID
  const fetchImageServer = async (url) => {
    try {
      const response = await api.get(url, { responseType: 'blob' });
      const blobUrl = URL.createObjectURL(response.data);
      setImgSrc(blobUrl);
    } catch (error) {
      console.error('Image fetch failed:', error);
      setImgSrc(fallback);
      setIsError(true);
    } finally {
      setTimeout(() => {
        setIsLoaded(true);
      }, timeout);
    }
  };

  // Fungsi untuk menentukan sumber gambar
  const resolveImage = () => {
    
    if (!content) {
      setImgSrc(fallback);
      setTimeout(() => {
        setIsLoaded(true);
      }, timeout);
      return;
    }

    if (content.startsWith('data:')) {
      setImgSrc(content);
      setTimeout(() => {
        setIsLoaded(true);
      }, timeout);
      return;
    }

    fetchImageServer(content);
  };

  useEffect(() => {
    resolveImage();
  }, [content]);

  const handleLoad = (e) => {
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    setImgSrc(fallback);
    setIsError(true);
    if (onError) onError(e);
  };

  const handlePopup = () => {
    dialog.detail({
      content: (
        <img
          src={imgSrc}
          alt={alt}
          className="w-[300px] h-[300px] rounded-lg my-4 mx-auto"
          onLoad={handleLoad}
          onError={handleError}
        />
      )
    })
  }

  if (!isLoaded) {
    return (
      <div className={cn('w-full h-full flex items-center justify-center bg-primary-600/40', className)}>
        {/* <div className="spinner w-8 h-8" /> */}
        <img src="/assets/loading-qr.gif" alt="loading" className="w-full h-full rounded-lg" />
      </div>
    );
  }
  
  if (isError) {
    return (
      <div className={cn('w-full h-full flex items-center justify-center bg-primary-600/40', className)}>
        <ImageOff className='text-primary-500' />
      </div>
    );
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={cn({ 'cursor-pointer': popupImage }) + ' ' + className}
      onLoad={handleLoad}
      onError={handleError}
      onClick={() => popupImage && handlePopup()}
    />
  );
};

export default Image;